import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';
import styled from 'styled-components';

import Brochure from './Brochure/';
import Search from './Search/';
import User from './User/';
import Filters from './Filters';

import {
	Container,
	Section,
	UserAndLogo,
	BackButton,
	HideBelowWidth,
	HideBelowWidthInline,
	CollectionToggle,
} from './styles';
import ChangeLanguage from './User/ChangeLanguage';

const Logo = styled.div`
	svg {
		height: 30px;
	}
`;

import BrochureContext from 'contexts/Brochure';

const Header = props => {
	const { t, lng, collection } = props;

	const collectionData = collection !== null ? props.collections.find(c => c.id === collection) : false;
	let collectionBrochureCount = 0;

	if (collectionData) {
		collectionBrochureCount = collectionData.brochures.length;
	}

	return (
		<Container>
			<Section>
				<Switch>
					<Route exact path="/:language/t/" render={routeProps => <Filters {...routeProps} />} />
					<Route exact path="/:language/t/building/:buildingId/" render={() => <BackButton to={`/${lng}/t/`}>{t('header/Back to browse')}</BackButton>} />
					<Route path="/:language/t/brochure/:brochureId/:pageId?/" render={() => (
						<BrochureContext.Consumer>
							{ brochure => brochure === null ? null : (
								<BackButton to={`/${lng}/t/building/${brochure.building}/`}>
									<HideBelowWidthInline width="1250px">{t('header/Back to building')}</HideBelowWidthInline>
								</BackButton>
							)}
						</BrochureContext.Consumer>
					)} />
				</Switch>
			</Section>

			<Section center>
				<Switch>
					<Route exact path="/:language/t/" render={routeProps => <Search textSearchHandler={props.textSearchHandler} {...routeProps} />} />
					<Route path="/:language/t/brochure/:brochureId/:pageId?/" render={routeProps => (
						<Brochure
							updateBrochureHandler={props.updateBrochureHandler}
							togglePageListHandler={props.togglePageListHandler}
							toggleControlsHandler={props.toggleControlsHandler}
							toggleGeneratePdfOpen={props.toggleGeneratePdfOpen}
							baseUrl={props.baseUrl}
							{...routeProps}
						/>
					)} />
					<Route component={Section} />
				</Switch>
			</Section>

			<UserAndLogo>
				<CollectionToggle open={props.collectionsOpen} onClick={props.collectionOpenHandler}>
					{t('collection')} {collectionBrochureCount > 0 ? `(${collectionBrochureCount})` : ''}
				</CollectionToggle>
				<ChangeLanguage userOpenHandler={props.userOpenHandler} history={props.history} />
				<User
					history={props.history}
					userOpenHandler={props.userOpenHandler}
					logoutHandler={props.logoutHandler}
				/>
				<HideBelowWidth width="1100px">
					<Logo dangerouslySetInnerHTML={{__html: require(`!raw-loader!../../assets/${'logo-black'}.svg`) }} />
				</HideBelowWidth>
			</UserAndLogo>
		</Container>
	)
};

Header.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	history: PropTypes.object,
	collectionsOpen: PropTypes.bool,
	collections: PropTypes.array,
	collection: PropTypes.string,
	userOpenHandler: PropTypes.func,
	logoutHandler: PropTypes.func,
	updateBrochureHandler: PropTypes.func,
	togglePageListHandler: PropTypes.func,
	toggleControlsHandler: PropTypes.func,
	toggleGeneratePdfOpen: PropTypes.func,
	collectionOpenHandler: PropTypes.func,
	textSearchHandler: PropTypes.func,
};

export default withRouter(translate('translations')(Header))
